import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import {
  LOGIN_USER,
  LOGOUT_USER,
  SOCIAL_LOGIN,
  GOOGLE_SSO_LOGIN,
  GOOGLE_SSO_SET_COOKIE,
  POST_SSO_ONLY_LOGIN_STATUS, OKTA_SSO_LOGIN, INITIATE_OKTA_LOGIN_FLOW,
} from "./actionTypes";

import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  googleSsoLoginSuccess,
  googleSsoLoginError,
  googleSsoSetCookieSuccess,
  googleSsoSetCookieError,
  postSsoOnlyLoginStatusSuccess,
  postSsoOnlyLoginStatusError, oktaSsoLoginSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  logoutUrl,
  postFakeLogin,
  postJwtLogin,
  postSocialLogin, resetPasswordUrl,
  googleSsoLoginUrl,
  googleSsoSetCookieUrl,
  postSsoOnlyLoginStatusUrl,
  oktaLoginUrl, oktaLoginFlowUrl,
} from "../../../helpers/fakebackend_helper";
import {showNotification} from "../../../components/Common/notification";

// import { setShowToast } from '../../toast/actions';

const fireBaseBackend = getFirebaseBackend();


function* googleSsoSetCookie(data) {
  try {
    const response = yield call(googleSsoSetCookieUrl, data["payload"]);

    let BASE_URL = window.location.protocol + "//" + response['domain'];

    if (response['next_url'] && response['next_url'] !== '') {
        window.location.href = BASE_URL + response['next_url'];
    }
    else
    {
        window.location.href = BASE_URL + "/dashboard";
    }

    yield put(googleSsoSetCookieSuccess(response));
  }
  catch (error) {
    yield put(googleSsoSetCookieError(error.message));
  }
}


function* googleSsoLoginUser({ payload: { access_token } }) {

  try {
    const response = yield call(googleSsoLoginUrl, access_token);

    let BASE_URL = window.location.protocol + "//" + response['domain'];
    const url = new URL(BASE_URL);

    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);
    const next = params.get('next');
    const decodedNext = next ? decodeURIComponent(next) : null;

    const new_params = new URLSearchParams();
    new_params.append('token', response['token']);
    new_params.append('isCloudLoaded', response['is_cloud_onboarded']);
    new_params.append('isServiceLoaded', response['is_service_onboarded']);
    new_params.append('fyno_signature', response['fyno_signature']);
    new_params.append('user_id', response['user_id']);
    new_params.append('access_token', response['access_token']);
    new_params.append('refresh_token', response['refresh_token']);

    if (response['is_cloud_onboarded']) {
      //window.location.href = decodedNext ? `${BASE_URL}${decodedNext}` : `${BASE_URL}/dashboard`;
      // if (response['next_url'] && response['next_url'] !== '') {
      //   window.location.href = BASE_URL + response['next_url'] + "?" + queryString;
      // }
      // else {
      url.pathname = '/dashboard';
      url.search = new_params.toString();
      //window.location.href = BASE_URL + "/dashboard"+ "?" + queryString;
      //}
      localStorage.setItem("state_of_toast", true);
      // history('/dashboard');
      // yield put(setShowToast(true));
    } else {
      url.pathname = '/onboarding';
      url.search = new_params.toString();
      //window.location.href = BASE_URL + "/onboarding"+ "?" + queryString;
      // history('/onboarding');
    }

    window.location.href = url.toString();
  }
  catch (error) {
        yield put(googleSsoLoginError(error.message));
  }
}


function* loginUser({ payload: { user, history } }) {
  try {
    const data ={
      subdomain_name: user.subdomain_name,
      email: user.email,
      password: user.password,
      next_url: user.next
    }
    if(user.request_otp && user.request_otp === true){
      data['request_otp'] = user.request_otp
    }
    if(user.otp_for_verification && user.otp_for_verification !== ''){
      data['otp_for_verification'] = user.otp_for_verification
    }
    const response = yield call(postJwtLogin, data);
    let BASE_URL;
    localStorage.setItem("isCloudLoaded", response['is_cloud_onboarded']);
    localStorage.setItem("isServiceLoaded", response['is_service_onboarded']);
    localStorage.setItem("fyno_signature", response['fyno_signature']);
    localStorage.setItem("user_id", response['user_id']);
    BASE_URL = window.location.protocol + "//" + response['domain'];
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);
    const next = params.get('next');
    const decodedNext = next ? decodeURIComponent(next) : null;
    if (response['is_two_factor_auth_enabled'] === false){
      localStorage.setItem("authUser", response['token']);
      if (response['is_cloud_onboarded']) {
        window.location.href = decodedNext ? `${BASE_URL}${decodedNext}` : `${BASE_URL}/dashboard`;
        if (response['next_url'] && response['next_url'] !== '') {
          window.location.href = BASE_URL + response['next_url'];
        }
        else {
          window.location.href = BASE_URL + "/dashboard";
        }
        localStorage.setItem("state_of_toast", true);
      } else {
        window.location.href = BASE_URL + "/onboarding";
      }
    }else if (response['is_two_factor_auth_enabled'] === true && response['otp_verified'] === true){
      localStorage.setItem("authUser", response['token']);
      if (response['is_cloud_onboarded']) {
        window.location.href = decodedNext ? `${BASE_URL}${decodedNext}` : `${BASE_URL}/dashboard`;
        if (response['next_url'] && response['next_url'] !== '') {
          window.location.href = BASE_URL + response['next_url'];
        }
        else {
          window.location.href = BASE_URL + "/dashboard";
        }
        localStorage.setItem("state_of_toast", true);
      } else {
        window.location.href = BASE_URL + "/onboarding";
      }
    }
    yield put(loginSuccess(response));
  } catch (error) {
    yield put(apiError(error.response.data.message));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("fyno_signature");
    localStorage.removeItem("user_id");
    const response = yield call(logoutUrl);
    yield put(logoutUserSuccess(response.message));
    history('/login');
  }
  catch (error) {
    yield put(apiError(error.message));
  }
}

function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, type);
      if (response) {
        history("/dashboard");
      } else {
        history("/login");
      }
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    if (response)
      history("/dashboard");
  } catch (error) {
    yield put(apiError(error.response.data.message));
  }
}

function* postSsoOnlyLoginStatus({ payload: { subdomain } }) {
    try {
      const response = yield call(postSsoOnlyLoginStatusUrl, {
        subdomain: subdomain
      })

        yield put(postSsoOnlyLoginStatusSuccess(response));
    }
    catch (error) {
      yield put(postSsoOnlyLoginStatusError(error.message));
    }
}

function* onOktaLogin() {
  try {
    const response = yield call(oktaLoginUrl);
    if (response && response['status']===404){
      showNotification('error', response['message']);
    }
    else if (response) {
      window.location.href = response['url'];
    }
  } catch (error) {
    showNotification('error', error.message);
  }
}

function* onInitiateOktaLoginFlow({ payload:data }) {
  try {
    const response = yield call(oktaLoginFlowUrl, data);
    let BASE_URL = window.location.protocol + "//" + response['domain'];
    const url = new URL(BASE_URL);
    const new_params = new URLSearchParams();
    new_params.append('token', response['token']);
    new_params.append('isCloudLoaded', response['is_cloud_onboarded']);
    new_params.append('isServiceLoaded', response['is_service_onboarded']);
    new_params.append('fyno_signature', response['fyno_signature']);
    new_params.append('user_id', response['user_id']);
    new_params.append('access_token', response['access_token']);
    new_params.append('refresh_token', response['refresh_token']);
    localStorage.setItem("isCloudLoaded", response['is_cloud_onboarded']);
    localStorage.setItem("isServiceLoaded", response['is_service_onboarded']);
    localStorage.setItem("fyno_signature", response['fyno_signature']);
    localStorage.setItem("user_id", response['user_id']);

    if (response['is_cloud_onboarded']) {
      url.pathname = '/dashboard';
      url.search = new_params.toString();
      localStorage.setItem("state_of_toast", true);
    } else {
      url.pathname = '/onboarding';
      url.search = new_params.toString();
    }
    window.location.href = url.toString();
  }
  catch (error) {
    yield put(googleSsoLoginError(error.message));
  }
}


function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(GOOGLE_SSO_LOGIN, googleSsoLoginUser)
  yield takeEvery(GOOGLE_SSO_SET_COOKIE, googleSsoSetCookie)
  yield takeEvery(POST_SSO_ONLY_LOGIN_STATUS, postSsoOnlyLoginStatus)
  yield takeEvery(OKTA_SSO_LOGIN, onOktaLogin)
  yield takeEvery(INITIATE_OKTA_LOGIN_FLOW, onInitiateOktaLoginFlow)
}

export default authSaga;
